//const url = 'http://localhost:8003';

const url = process.env.REACT_APP_URL
const pathImg = process.env.REACT_APP_PATHIMG
const appName = process.env.REACT_APP_APPNAME
export default { url, pathImg, appName }